/**
 * Shopify Parameters Utility
 * 
 * Extracts shop and host parameters needed for App Bridge initialization
 * and authentication. These parameters are provided by Shopify in the URL
 * when the app is first loaded, but may need to be persisted for subsequent
 * page loads.
 * 
 * Note: With App Bridge v4, these parameters are still required for initial
 * configuration and authentication, even though the App Bridge itself is
 * automatically initialized.
 */

export const getHost = (): string => {
  // First try URL parameters, then fall back to localStorage
  return (
    new URLSearchParams(window.location.search).get('host') ||
    localStorage.getItem('shopify_host') ||
    ''
  )
}

export const getShop = (): string => {
  // First try URL parameters, then fall back to localStorage  
  return (
    new URLSearchParams(window.location.search).get('shop') ||
    localStorage.getItem('shopify_shop') ||
    ''
  )
}

export const getShopifyParams = () => {
  const shop = getShop()
  const host = getHost()
  
  return { 
    shop: shop || '', 
    host: host || '' 
  }
}

/**
 * Helper to check if we have the minimum required Shopify parameters
 */
export const hasRequiredShopifyParams = () => {
  const { shop, host } = getShopifyParams()
  return !!(shop && host)
}
